import React, { Component } from 'react';
// jQuery plugin - used for DataTables.net
import $ from 'jquery';
import {
    Grid, Row, Col
} from 'react-bootstrap';
import {
    Tooltip,
} from 'react-tippy';
import { connect } from 'react-redux'
import api from '../../../../services/index'
import { firebaseAuthentication } from '../../../../authentication'
import { adminAction } from '../../../../actions'

import { appAction } from '../../../../actions'

import Card from '../../../../components/Card/Card.jsx';

import * as moment from 'moment'
import SweetAlert from 'react-bootstrap-sweetalert';
// DataTables.net plugin - creates a tables with actions on it
require('datatables.net-responsive');
$.DataTable = require('datatables.net-bs');




const dataTable = {
    headerRow: ['STT', 'Tên', 'Trang kết nối', 'Ngày tạo', 'Ngày hết hạn', 'Hành động'],
    footerRow: ['STT', 'Tên', 'Trang kết nối', 'Ngày tạo', 'Ngày hết hạn', 'Hành động'],
    dataRows: [
        ['Airi Satou', 'Andrew Mike', 'Develop', '2013', '99,225'],
    ]
};

class Apps extends Component {
    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            showAlert: false,
            headerRow: ['STT', "ID", 'Tên', 'Trang kết nối', 'Chủ sở hữu', 'Ngày tạo', 'Ngày hết hạn', 'Gói', 'Hành động'],
            footerRow: ['STT', 'ID', 'Tên', 'Trang kết nối', 'Chủ sở hữu', 'Ngày tạo', 'Ngày hết hạn', 'Gói', 'Hành động'],
            apps: []
        }
        this.upgradeLicense = this.upgradeLicense.bind(this)
        this.showUpgradeLicense = this.showUpgradeLicense.bind(this)
        this.hideAlert = this.hideAlert.bind(this);
    }
    hideAlert() {
        this.setState({
            alert: null
        });
    }
    async showUpgradeLicense(appId, licenseId, index) {
        const app = this.props.apps.find(app => { return app._id === appId })
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Bạn có chắc chắn muốn nâng cấp app này?"
                    onConfirm={() => this.upgradeLicense(appId, licenseId, index)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Nâng cấp"
                    cancelBtnText="Thoát"
                    showCancel
                >
                    App hết hạn vào ngày {moment(app.license.expireDate).format(`DD/MM/YYYY`)}
                </SweetAlert>
            )
        });
    }
    async upgradeLicense(appId, licenseId, index) {
        const token = this.props.admin.superToken
        try {
            const result = await api.superAdmin.upgradeLicense(token, appId, "basic")
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Thành công"
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                    >
                        Gia hạn app thành công
                    </SweetAlert>
                )
            });
            this.props.apps[index].license = result
            this.props.dispatch(appAction.update(this.props.apps[index]))
            this.forceUpdate()
        } catch (err) {
            this.setState({
                alert: (
                    <SweetAlert
                        style={{ display: "block", marginTop: "-100px" }}
                        title="Gia hạn không thành công"
                        onConfirm={() => this.hideAlert()}
                        onCancel={() => this.hideAlert()}
                        confirmBtnBsStyle="info"
                    />
                )
            })
        }
    }
    async componentDidMount() {
        try {
            const token = this.props.admin.superToken
            if (this.props.apps.length === 0) {
                const apps = await api.superAdmin.getApps(token, { query: { populates: ["activePage", "license"], limit: 0, order: "-createdAt", } })
                this.props.dispatch(appAction.fetch(apps))
                this.forceUpdate()
            }
        } catch (err) {
            console.error(err)
        }
        $("#datatables").DataTable({
            "pagingType": "full_numbers",
            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
            responsive: true,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Tìm kiếm",
            }
        });
    }
    componentWillUnmount() {
        $('.data-table-wrapper')
            .find('table')
            .DataTable()
            .destroy(true);
    }
    shouldComponentUpdate() {
        return true;
    }
    async componentWillMount() {
        if (!this.props.admin.superToken) {
            try {
                this.props.history.push("/dashboard")
                // const firebaseToken = await firebaseAuthentication.getIdToken()
                // const result = await api.superAdmin.login(firebaseToken)
                // this.props.dispatch(adminAction.login({ firebaseToken: firebaseToken, superToken: result.superToken }))
            } catch (err) {
                const result = await firebaseAuthentication.signOut()
                this.props.dispatch(adminAction.logout())
                this.props.history.push("/page/login-page")
            }
        }
    }
    render() {
        const { headerRow, footerRow } = this.state
        return (
            <div className="main-content">
                {this.state.alert}
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <h2 className="title">Danh sách app</h2>
                            <Card
                                content={
                                    <div className="fresh-datatables">
                                        <table id="datatables" ref="main" className="table table-striped table-no-bordered table-hover" cellSpacing="0" width="100%" style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>{headerRow[0]}</th>
                                                    <th>{headerRow[1]}</th>
                                                    <th>{headerRow[2]}</th>
                                                    <th>{headerRow[3]}</th>
                                                    <th>{headerRow[4]}</th>
                                                    <th>{headerRow[5]}</th>
                                                    <th>{headerRow[6]}</th>
                                                    <th>{footerRow[7]}</th>
                                                    <th className="disabled-sorting text-right">{headerRow[8]}</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>{footerRow[0]}</th>
                                                    <th>{footerRow[1]}</th>
                                                    <th>{footerRow[2]}</th>
                                                    <th>{footerRow[3]}</th>
                                                    <th>{footerRow[4]}</th>
                                                    <th>{footerRow[5]}</th>
                                                    <th>{footerRow[6]}</th>
                                                    <th>{footerRow[7]}</th>
                                                    <th className="text-right">{footerRow[8]}</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {
                                                    this.props.apps.map((app, key) => {
                                                        const owner = app.users.find((user) => { return user.uid === app.owner }) || {}
                                                        //const package = app.license.package
                                                        return (
                                                            <tr key={key}>
                                                                <td >{key + 1}</td>
                                                                <td >{app._id}</td>
                                                                <td >{app.name}</td>
                                                                <td >{app.activePage && app.activePage.name ? app.activePage.name : ""}</td>
                                                                <td>{owner.name || owner.email}</td>
                                                                <td >{moment(app.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                                                                <td >{app.license ? moment(app.license.expireDate).format("DD/MM/YYYY HH:mm") : null}</td>
                                                                <td >{app.license ? app.license.package : null}</td>
                                                                <td className="text-right">
                                                                    <Tooltip
                                                                        title="Gia hạn"
                                                                        position="top"
                                                                    >
                                                                        <a className="btn btn-simple btn-info btn-icon like" onClick={() => { return this.showUpgradeLicense(app._id, app.license._id, key) }}><i className="far fa-calendar"></i></a>
                                                                    </Tooltip>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(Apps);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Components/Apps/Apps.jsx